module.exports = __webpack_public_path__ + "static/media/7879.9c6da3c5.png";